<div class="discount" *ngIf="isPromotion">
  {{ (isFrom ? ('discountFrom' | translate) + ' ' : '') + "-" + promotionPrice + "%" }}
</div>
